import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import {Stack} from "@mui/material";

import {useDispatch} from "react-redux";

import {changeWorkIssuance} from "../workIssuanceSlice";
import {changeWork} from "../../Work/workSlice";



export default function WorkIssuanceCalcPayTabs(props) {
    const [workIssuanceTabValue, setWorkIssuanceTabValue] = React.useState(0);

    const dispatchData = useDispatch();


    const handleChange = (event, newValue) => {
        setWorkIssuanceTabValue(newValue);
        if(newValue == 0){
            dispatchData(changeWorkIssuance({calcTabState: true, payTabState: false, owedGridState: true,obligationGridState: false,offsetsGridState: false,paymentGridState: false,fringeGridState: false,
                taxGridState: false,expenseGridState: false, requestGridState: false, confirmationGridState: false,clearData: true, fetchProductId: 0,
                calcSearchProductId: 0,
                versionMode: null,
                versionStatusId: null,
                versionStatusName: null,
                periodEndDate: null,
                testScenarioNumber : null,
                testScenarioName : null,
                testScenarioPropertyId : null,
                testScenarioPropertyName : null}));
            dispatchData(changeWork({propertyId: 0}));
            console.log("show calc tabs");
        }
        if(newValue == 1){
            dispatchData(changeWorkIssuance({calcTabState: false, payTabState: true, owedGridState: false, obligationGridState: false,
                offsetsGridState: false,paymentGridState: false,fringeGridState: false,taxGridState: false,expenseGridState: true,
                requestGridState: false, confirmationGridState: false,clearData: true, fetchProductId: 0,
                calcSearchProductId: 0,
                versionMode: null,
                versionStatusId: null,
                versionStatusName: null,
                periodEndDate: null,
                testScenarioNumber : null,
                testScenarioName : null,
                testScenarioPropertyId : null,
                testScenarioPropertyName : null}));

            dispatchData(changeWork({propertyId: 0}));
            console.log("show pay tabs");
        }
    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2, pl: 3,   height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={workIssuanceTabValue}
                      defaultValue={0}
                      onChange={handleChange} >
                    <Tab  label="Calc Results" title="Obligation, Offset and Owed"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab  label="Payment Details" title="Fringe, Payment, Tax and Expense"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                </Tabs>
            </Box>
        </Stack>
    );
}
